import { SectionHeading } from './SectionHeading'

export function Contact() {
  return (
    <section
      id="contact"
      className="section-wrapper relative overflow-hidden bg-white"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-white via-blue-50/30 to-slate-50" />

      <div className="container-inner relative z-10">
        <SectionHeading subtitle="Contact Us" title="お問い合わせ" />

        <div className="max-w-2xl mx-auto text-center animate-on-scroll animate-on-scroll-delay-1">
          <div className="bg-white border border-slate-100 rounded-2xl shadow-sm p-10 mb-8">
            <p className="text-brand-navy/50 text-sm leading-relaxed mb-2">
              受付時間
            </p>
            <p className="text-brand-navy font-semibold mb-6">
              平日 9:00〜18:00
            </p>

            <div className="flex items-center justify-center gap-3 mb-8">
              <div className="w-8 h-8 rounded-full bg-brand-cyan/15 flex items-center justify-center">
                <span className="text-brand-cyan text-sm">✉</span>
              </div>
              <a
                href="mailto:inquiry@jfrontier.net"
                className="text-brand-blue hover:underline text-lg font-medium"
              >
                inquiry@jfrontier.net
              </a>
            </div>

            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a href="mailto:inquiry@jfrontier.net" className="btn-primary">
                お問い合わせ
              </a>
              <a
                href="https://jfrontier.net/jfrontier_works.pdf"
                target="_blank"
                rel="noopener noreferrer"
                download="jfrontier_works.pdf"
                className="btn-outline border-brand-navy/30 text-brand-navy/70 hover:bg-brand-navy/5 hover:border-brand-navy/60"
              >
                会社案内をダウンロード
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
